module.exports = __webpack_public_path__ + "assets/c28c2fa46e916ec6d990f23dc6989105.mp3";